import React, { useState } from 'react';
import './Alert.css';

export interface AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'danger';
  title?: string;
  dismissible?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onDismiss?: () => void;
}

const defaultIcons: Record<string, string> = { info: 'ℹ️', success: '✅', warning: '⚠️', danger: '❌' };

export function Alert({ variant = 'info', title, dismissible = false, icon, children, className = '', style, onDismiss }: AlertProps) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className={`ui-alert ui-alert-${variant} ${className}`} role="alert" style={style}>
      <span className="ui-alert-icon">{icon || defaultIcons[variant]}</span>
      <div className="ui-alert-content">
        {title && <div className="ui-alert-title">{title}</div>}
        <div className="ui-alert-message">{children}</div>
      </div>
      {dismissible && (
        <button className="ui-alert-close" onClick={() => { setVisible(false); onDismiss?.(); }} aria-label="Close">×</button>
      )}
    </div>
  );
}
